/** @fileoverview get_user_analytics_key_events の共通定数 */

export const GET_USER_ANALYTICS_KEY_EVENTS_NAME =
  "get_user_analytics_key_events" as const;

export const GET_USER_ANALYTICS_KEY_EVENTS_DESC = `Fetches key events for a User Analytics project.

Use this when a user asks which key events are configured for a UA project or wants to confirm conversion-related events.

Input:
- 'projectId' (required): The ID of the User Analytics project.

Output:
- { projectId, projectName, userAnalyticsId, keyEvents, eventNames }
  - 'keyEvents': The conversion-defining events currently configured for the project.
  - 'eventNames': All event names observed for the project (for context).

Notes:
- Read-only. Does not create, update, or delete anything.
- Fails if the project is not a User Analytics project.`;
